import { getFullName } from '../../util';

export const loggedOn = (state) => state.user.has('loggedOn');

export const selectCurrentUser = (state) => {
  const user = state.user.toJS();
  if (!loggedOn(state)) return user;
  return { ...user, fullName: getFullName(user) };
};
export const selectCurrentUserId = (state) => state.user.get('id');
export const isBeaglyAdmin = (state) => state.user.get('role') === 'admin';

export const selectToken = (state) => state.user.get('token');

export const makeIsOrgAdminPredicate = (state) => (organization) => {
  const beaglyAdmin = isBeaglyAdmin(state);
  const organizationAdmin = organization.getIn(['membership', 'role']) === 'admin';
  return beaglyAdmin || organizationAdmin;
};
